import {
  FETCH_RELEASE_NOTES_REQUEST,
  FETCH_RELEASE_NOTES_SUCCESS,
  FETCH_RELEASE_NOTES_FAILURE,
  OPEN_EDIT_RELEASE_NOTE_PAGE,
  FETCH_RELEASE_NOTE_REQUEST,
  FETCH_RELEASE_NOTE_SUCCESS,
  FETCH_RELEASE_NOTE_FAILURE,
  UPDATE_RELEASE_NOTES_REQUEST,
  UPDATE_RELEASE_NOTES_FAILURE,
  UPDATE_RELEASE_NOTES_SUCCESS,
  DELETE_RELEASE_NOTES_REQUEST,
  DELETE_RELEASE_NOTES_FAILURE,
  DELETE_RELEASE_NOTES_SUCCESS,
  CLEAR_RELEASE_NOTE_ERRORS,    // Nouvelles imports
  CLEAR_RELEASE_NOTE_SUCCESS,
} from './actionTypes';

const initialState = {
  releaseNotes: [],
  releaseNote: null,
  loadingReleaseNote: false,
  errorReleaseNote: null,
  editItemId: null,
  releaseNoteAdded: null
};

const ReleaseNotes = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RELEASE_NOTES_REQUEST:
      return {
        ...state,
        loadingReleaseNote: true,
        errorReleaseNote: null,
        releaseNoteAdded: false
      };
    case FETCH_RELEASE_NOTES_SUCCESS:
      return {
        ...state,
        loadingReleaseNote: false,
        releaseNotes: action.payload,
      };
    case FETCH_RELEASE_NOTES_FAILURE:
      return {
        ...state,
        loadingReleaseNote: false,
        errorReleaseNote: action.payload,
      };
    case FETCH_RELEASE_NOTE_REQUEST:
      return {
        ...state,
        loadingReleaseNote: true,
        errorReleaseNote: null,
        releaseNoteAdded: false
      };
    case FETCH_RELEASE_NOTE_SUCCESS:
      return {
        ...state,
        loadingReleaseNote: false,
        releaseNote: action.payload,
      };
    case FETCH_RELEASE_NOTE_FAILURE:
      return {
        ...state,
        loadingReleaseNote: false,
        errorReleaseNote: action.payload,
      };
    case UPDATE_RELEASE_NOTES_REQUEST:
      return {
        ...state,
        loadingReleaseNote: true,
        errorReleaseNote: null,
        releaseNoteAdded: false
      };
    case UPDATE_RELEASE_NOTES_SUCCESS:
      return {
        ...state,
        loadingReleaseNote: false,
        releaseNote: null,
        releaseNoteAdded: true
      };
    case UPDATE_RELEASE_NOTES_FAILURE:
      return {
        ...state,
        loadingReleaseNote: false,
        errorReleaseNote: action.payload,
      };
    case DELETE_RELEASE_NOTES_REQUEST:
      return {
        ...state,
        loadingReleaseNote: true,
        errorReleaseNote: null,
        releaseNoteAdded: false
      };
    case DELETE_RELEASE_NOTES_SUCCESS:
      return {
        ...state,
        releaseNoteAdded: true,
        loadingReleaseNote: false,
        releaseNotes: state.releaseNotes.filter(releaseNote => releaseNote.id !== action.payload),
      };
    case DELETE_RELEASE_NOTES_FAILURE:
      return {
        ...state,
        loadingReleaseNote: false,
        errorReleaseNote: action.payload,
      };
    case OPEN_EDIT_RELEASE_NOTE_PAGE:
      return {
        ...state,
        editItemId: action.payload.id,
      };
    case CLEAR_RELEASE_NOTE_ERRORS:
      return {
        ...state,
        errorReleaseNote: null,
      };
    case CLEAR_RELEASE_NOTE_SUCCESS:
      return {
        ...state,
        releaseNoteAdded: null,
      };
      
    default:
      return state;
  }
};

export default ReleaseNotes;